import { useEffect, useState } from 'react';
import { Card, Statistic, Row, Col, Spin, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ShoppingCartOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

const API = import.meta.env.VITE_API_BASE || '/api';
const token = () => localStorage.getItem('ar_token');
const h = () => ({ Authorization: 'Bearer ' + token() });

export default function CustomerStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dealers, setDealers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(API + '/arrival/stats', { headers: h() }).then(r => {
      if (r.data.success) setStats(r.data);
    }).catch(() => {});
    axios.get(API + '/arrival/dealer-stats', { headers: h() }).then(r => {
      if (r.data.success) setDealers(r.data.data || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spin style={{ display: 'block', margin: '20vh auto' }} size="large" />;

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}><Card><Statistic title="待签收" value={stats?.unsigned || 0} prefix={<ClockCircleOutlined />} valueStyle={{ color: '#faad14' }} /></Card></Col>
        <Col span={8}><Card><Statistic title="已签收" value={stats?.signed || 0} prefix={<CheckCircleOutlined />} valueStyle={{ color: '#52c41a' }} /></Card></Col>
        <Col span={8}><Card><Statistic title="总数" value={stats?.total || 0} prefix={<ShoppingCartOutlined />} /></Card></Col>
      </Row>
      <Card title="经销商签收统计">
        <Table dataSource={dealers} rowKey="dealer_name" size="small" columns={[
          { title: '经销商', dataIndex: 'dealer_name' },
          { title: '总数', dataIndex: 'total' },
          { title: '已签收', dataIndex: 'signed' },
          { title: '待签收', dataIndex: 'unsigned' },
          { title: '签收率', dataIndex: 'rate' },
        ]} />
      </Card>
    </div>
  );
}
